<form [formGroup]="form">
  <mat-card class="loading-card">
    <mat-card-header class="loading-header" [ngClass]="{ loading: loading }">
      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    </mat-card-header>
    <mat-card-content>
      <h3>
        Synchronization configuration for different features of an organisation
      </h3>
      <div *ngIf="!loading && !editing && creating" class="create-config">
        <p>
          No <code>features</code> configuration for organisation with tag
          <code>{{ this.orgTag }}</code> was found.
        </p>
        <button mat-raised-button color="primary" (click)="startCreating()">
          Add configuration
        </button>
      </div>
      <mat-accordion [multi]="true" *ngIf="editing && !loading">
        <mat-expansion-panel [expanded]="true" formGroupName="card">
          <mat-expansion-panel-header>
            <mat-panel-title> Cards </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card
            class="card-control deletable mat-elevation-z0"
            formGroupName="BCITI"
          >
            <div>
              <h4>{{ CardType.BCITI }}</h4>
              <mat-checkbox formControlName="canUpdate"
                >Can update</mat-checkbox
              >
              <mat-checkbox formControlName="discrepancies"
                >Discrepancies</mat-checkbox
              >
            </div>
            <div>
              <button
                mat-icon-button
                *ngIf="canDeleteCardControl(CardType.BCITI)"
                (click)="removeCardControl(CardType.BCITI)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </mat-card>
          <mat-card
            class="card-control deletable mat-elevation-z0"
            formGroupName="CITIZEN"
          >
            <div>
              <h4>{{ CardType.CITIZEN }}</h4>
              <mat-checkbox formControlName="canUpdate"
                >Can update</mat-checkbox
              >
              <mat-checkbox formControlName="discrepancies"
                >Discrepancies</mat-checkbox
              >
            </div>
            <div>
              <button
                mat-icon-button
                *ngIf="canDeleteCardControl(CardType.CITIZEN)"
                (click)="removeCardControl(CardType.CITIZEN)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </mat-card>
          <mat-card
            class="card-control mat-elevation-z0"
            formGroupName="SPORTS"
          >
            <h4>{{ CardType.SPORTS }}</h4>
            <mat-checkbox formControlName="canUpdate">Can update</mat-checkbox>
            <mat-checkbox formControlName="discrepancies"
              >Discrepancies</mat-checkbox
            >
          </mat-card>
          <mat-card
            class="card-control mat-elevation-z0"
            formGroupName="LIBRARY"
          >
            <h4>{{ CardType.LIBRARY }}</h4>
            <mat-checkbox formControlName="canUpdate">Can update</mat-checkbox>
            <mat-checkbox formControlName="discrepancies"
              >Discrepancies</mat-checkbox
            >
          </mat-card>
          <mat-card
          class="card-control mat-elevation-z0"
          formGroupName="LEGACY"
        >
          <h4>{{ CardType.LEGACY }}</h4>
          <mat-checkbox formControlName="canUpdate">Can update</mat-checkbox>
          <mat-checkbox formControlName="discrepancies"
            >Discrepancies</mat-checkbox
          >
        </mat-card>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true" formGroupName="cardRequiredFields">
            <mat-expansion-panel-header>
                <mat-panel-title> Required cards fields </mat-panel-title>
            </mat-expansion-panel-header>
            <p>Default and required fields: {{defaultRequiredFieldsForCard}} - If they are not selected, they will be automatically selected after saving</p>
            <div class="prevent-admin-notifications" >
                <div class="item" *ngFor="let i of requiredFieldsForCard" >
                    <mat-checkbox [formControlName]="i">{{i}} </mat-checkbox>
                </div>
            </div>
            <div></div>
        </mat-expansion-panel> 
        <mat-expansion-panel [expanded]="true" formGroupName="news">
          <mat-expansion-panel-header>
            <mat-panel-title> News </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-checkbox formControlName="sync">Sync</mat-checkbox>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" formGroupName="notices">
          <mat-expansion-panel-header>
            <mat-panel-title> Notices </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-checkbox formControlName="sync">Sync</mat-checkbox>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" formGroupName="requests">
          <mat-expansion-panel-header>
            <mat-panel-title> Requests </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-checkbox formControlName="sync">Sync</mat-checkbox>
          <mat-card
            class="card-control mat-elevation-z0"
            formGroupName="status"
          >
          <h4>Status</h4>
          <mat-checkbox formControlName="enableAdminChanges">Admin can update</mat-checkbox>
        </mat-card>

        <mat-card
            class="card-control mat-elevation-z0"
            formGroupName="pgRequetesIframe"
          >
          <h4>PG requêtes</h4>
          <div class="col-12 d-flex flex-column">
            <mat-checkbox formControlName="active">Active PG Requêtes iframe</mat-checkbox>

            <mat-form-field appearance="outline">
              <mat-label>external URL</mat-label>
              <input matInput type="text" formControlName="url" placeholder="https://ville.edemandes.com/fr/create?display=external&product=XYZ" />
            </mat-form-field>
          </div>
        </mat-card>
        </mat-expansion-panel>

        <mat-expansion-panel
          [expanded]="true"
          formGroupName="pgpermit"
        >
          <mat-expansion-panel-header>
            <mat-panel-title> PG permits </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="col-12 d-flex flex-column">

            <mat-form-field appearance="outline">
              <mat-label>external URL</mat-label>
              <input matInput type="text" formControlName="url" placeholder="https://ville.edemandes.com/fr/create?display=external&product=XYZ" />
            </mat-form-field>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel
          [expanded]="true"
          formGroupName="requestCategories"
        >
          <mat-expansion-panel-header>
            <mat-panel-title> Request categories </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-checkbox formControlName="sync">Sync</mat-checkbox>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" formGroupName="serviceState">
          <mat-expansion-panel-header>
            <mat-panel-title> Service state </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-checkbox formControlName="sync">Sync</mat-checkbox>
        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="true" formGroupName="family">
          <mat-expansion-panel-header>
            <mat-panel-title> Family </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card
            class="card-control mat-elevation-z0"
            formGroupName="link"
          >
            <h4>Links</h4>
            <p>This will activate the synchroniser function to check if a family link is expired and need to be "pending admin approval"</p>
            <p>Don't forget to add configurations in platform options</p>
            <mat-checkbox formControlName="enableExpiration">Family link can expire</mat-checkbox>
          </mat-card>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" formGroupName="address">
            <mat-expansion-panel-header>
              <mat-panel-title> Address </mat-panel-title>
            </mat-expansion-panel-header>
            <p>This will only be applied on the renewal of a subscription</p>
            <mat-checkbox formControlName="avs">Address Verification System (via Credit cart)</mat-checkbox>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true" formGroupName="preventAdminNotifications">
          <mat-expansion-panel-header>
            <mat-panel-title> Prevent admin notifications </mat-panel-title>
          </mat-expansion-panel-header>
          <p>This feature disables sending emails to the administrator. For example, enabling this option for "PROFILE" would prevent map creation and family link emails from being sent to city administrators.</p>
          <p>Distribution list is the list of emails that needs to be notified. </p>
          
            <div class="prevent-admin-notifications" >
              <div
                *ngFor="let i of availableModules" 
                class="item"
                [formGroupName]="i"
              >
                <mat-checkbox

                 formControlName="prevent"
                >
                  {{i}} 
                </mat-checkbox>
                <div class="w-full"></div>
                <mat-form-field class="w-50" *ngIf="isModulePreventEnabled(i)" appearance="outline">
                  <mat-label>Distribution list - Comma separated (opt.)</mat-label>
                  <input matInput formControlName="distributionList" />
                </mat-form-field>
              </div>
              
            </div>
            <div>
            </div>
         
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
    <mat-card-footer *ngIf="editing">
      <button mat-raised-button (click)="reset()">Reset</button>
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="loading"
        (click)="handleSubmit()"
      >
        <mat-icon>save</mat-icon>
        Save
      </button>
    </mat-card-footer>
  </mat-card>
</form>
